import { Component } from '@angular/core';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';
import { MatDialog } from '@angular/material/dialog';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { FeatureTogglesFacade } from '@cigna/features';

@Component({
  selector: 'cigna-page-review-changes',
  templateUrl: './page-review-changes.component.html',
  styleUrls: ['./page-review-changes.component.scss'],
})
export class PageReviewChangesComponent {
  constructor(
    private manageAccessFacade: ManageUserAccessFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
    public dialog: MatDialog,
    private authFacade: AuthFacade,
  ) {}

  impersonator$ = this.authFacade.isImpersonator$;
  steps$ = this.manageAccessFacade.steps$;
  selectedUserType$ = this.manageAccessFacade.selectedUserType$;
  selectedUsers$ = this.manageAccessFacade.selectedUsers$;
  hiddenSteps$ = this.manageAccessFacade.hiddenSteps$;
  submitting$ = this.manageAccessFacade.isSubmitting$;
  submitError$ = this.manageAccessFacade.submitError$;
  isEmailValid$ = this.manageAccessFacade.isEmailValid$;
  isEmailValidErrorMsg$ = this.manageAccessFacade.isEmailValidErrorMsg$;

  previousScreen(): void {
    this.manageAccessFacade.backToAssign();
  }

  nextScreen(): void {
    this.manageAccessFacade.submitEntitlements();
  }

  checkEmail(email: string): void {
    this.manageAccessFacade.checkEmail(email);
  }
}
